/* eslint-disable react/prop-types */
import "./styles.css";
function ProfileSwitch({ curProfile, setCurProfile }) {
  const profiles = [
    { name: "General", src: "./faq-general.svg" },
    { name: "Algos", src: "./faq-Workflow.svg" },
    { name: "Application Dev", src: "./faq-appdev.svg" },
    { name: "DevOps", src: "./faq-devops.svg" },
    { name: "EE", src: "./faq-EE.svg" },
    { name: "Robotics", src: "./faq-Robotics.svg" },
    { name: "ML", src: "./faq-ML.svg" },
    {name: "Cybersecurity", src: "./faq-cybersecurity.svg"},
    {name: "Networks", src: "./faq-networks.svg"},
    {name: "Blockchain", src: "./faq-blockchain.svg"}
  ];
  const moveLeft = () => {
    if (curProfile - 1 < 0) {
      setCurProfile(profiles.length - 1);
    } else {
      setCurProfile((x) => x - 1);
    }
  };
  const moveRight = () => {
    if (curProfile + 1 > profiles.length - 1) {
      setCurProfile(0);
    } else {
      setCurProfile((x) => x + 1);
    }
  };
  return (
    <div className="faq-profile-carousel">
      <img
        className="cursor-profile"
        src="./double-left.svg"
        alt="left"
        onClick={() => moveLeft()}
      />
      <div className="faq-profile-container">
        <div
          onClick={() => moveLeft()}
          id="profile-next"
          className={`cursor-profile`}
        >
          <img
            src={
              curProfile - 1 < 0
                ? profiles[profiles.length + curProfile - 1].src
                : profiles[curProfile - 1].src
            }
            alt="right"
          />
          <h3>
            {curProfile - 1 < 0
              ? profiles[profiles.length + curProfile - 1].name
              : profiles[curProfile - 1].name}
          </h3>
        </div>
        <div id="cur-profile" className="cursor-profile">
          <img className="faq-image" src={profiles[curProfile].src} alt="prev" />
          <h3>{profiles[curProfile].name}</h3>
        </div>
        <div
          onClick={() => moveRight()}
          id="profile-next"
          className={`cursor-profile`}
        >
          <img
            src={
              curProfile + 1 > profiles.length - 1
                ? profiles[-profiles.length + curProfile + 1].src
                : profiles[curProfile + 1].src
            }
            alt="cur"
          />
          <h3>
            {curProfile + 1 > profiles.length - 1
              ? profiles[-profiles.length + curProfile + 1].name
              : profiles[curProfile + 1].name}
          </h3>
        </div>
      </div>
      <img
        src="./double-right.svg"
        alt="next"
        onClick={() => moveRight()}
        className="cursor-profile"
      />
    </div>
  );
}

export default ProfileSwitch;
